"use strict";

var _classCallCheck = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
* @ignore
*/

exports.ERROR_CODES = {
  MISSING_PARAMETER: 'missing_parameter',
  REMOTE_SERVICE_ERROR: 'remote_service_error',
  INVALID_STATE: 'invalid_state',
  NO_SESSION_DATA: 'no_session_data',
  UNKNOWN: 'unknown'
};
Object.freeze(exports.ERROR_CODES);
/**
* @ignore
*/

var BlockstackError =
/*#__PURE__*/
function (_Error) {
  _inherits(BlockstackError, _Error);

  function BlockstackError(error) {
    var _this;

    _classCallCheck(this, BlockstackError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BlockstackError).call(this, error.message));
    _this.message = error.message;
    _this.code = error.code;
    _this.parameter = error.parameter ? error.parameter : null;
    return _this;
  }

  _createClass(BlockstackError, [{
    key: "toString",
    value: function toString() {
      return "".concat(_get(_getPrototypeOf(BlockstackError.prototype), "toString", this).call(this), "\n    code: ").concat(this.code, " param: ").concat(this.parameter ? this.parameter : 'n/a');
    }
  }]);

  return BlockstackError;
}(_wrapNativeSuper(Error));

exports.BlockstackError = BlockstackError;
/**
* @ignore
*/

var FileNotFound =
/*#__PURE__*/
function (_BlockstackError) {
  _inherits(FileNotFound, _BlockstackError);

  function FileNotFound(message) {
    var _this2;

    _classCallCheck(this, FileNotFound);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(FileNotFound).call(this, {
      message: message,
      code: 'file_not_found'
    }));
    _this2.name = 'FileNotFound';
    return _this2;
  }

  return FileNotFound;
}(BlockstackError);

exports.FileNotFound = FileNotFound;
/**
* @ignore
*/

var InvalidParameterError =
/*#__PURE__*/
function (_BlockstackError2) {
  _inherits(InvalidParameterError, _BlockstackError2);

  function InvalidParameterError(parameter) {
    var _this3;

    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _classCallCheck(this, InvalidParameterError);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(InvalidParameterError).call(this, {
      code: 'missing_parameter',
      message: message,
      parameter: ''
    }));
    _this3.name = 'MissingParametersError';
    return _this3;
  }

  return InvalidParameterError;
}(BlockstackError);

exports.InvalidParameterError = InvalidParameterError;
/**
* @ignore
*/

var MissingParameterError =
/*#__PURE__*/
function (_BlockstackError3) {
  _inherits(MissingParameterError, _BlockstackError3);

  function MissingParameterError(parameter) {
    var _this4;

    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _classCallCheck(this, MissingParameterError);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(MissingParameterError).call(this, {
      code: exports.ERROR_CODES.MISSING_PARAMETER,
      message: message,
      parameter: parameter
    }));
    _this4.name = 'MissingParametersError';
    return _this4;
  }

  return MissingParameterError;
}(BlockstackError);

exports.MissingParameterError = MissingParameterError;
/**
* @ignore
*/

var RemoteServiceError =
/*#__PURE__*/
function (_BlockstackError4) {
  _inherits(RemoteServiceError, _BlockstackError4);

  function RemoteServiceError(response) {
    var _this5;

    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _classCallCheck(this, RemoteServiceError);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(RemoteServiceError).call(this, {
      code: exports.ERROR_CODES.REMOTE_SERVICE_ERROR,
      message: message
    }));
    _this5.response = response;
    return _this5;
  }

  return RemoteServiceError;
}(BlockstackError);

exports.RemoteServiceError = RemoteServiceError;
/**
* @ignore
*/

var InvalidDIDError =
/*#__PURE__*/
function (_BlockstackError5) {
  _inherits(InvalidDIDError, _BlockstackError5);

  function InvalidDIDError() {
    var _this6;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, InvalidDIDError);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(InvalidDIDError).call(this, {
      code: 'invalid_did_error',
      message: message
    }));
    _this6.name = 'InvalidDIDError';
    return _this6;
  }

  return InvalidDIDError;
}(BlockstackError);

exports.InvalidDIDError = InvalidDIDError;
/**
* @ignore
*/

var NotEnoughFundsError =
/*#__PURE__*/
function (_BlockstackError6) {
  _inherits(NotEnoughFundsError, _BlockstackError6);

  function NotEnoughFundsError(leftToFund) {
    var _this7;

    _classCallCheck(this, NotEnoughFundsError);

    var message = "Not enough UTXOs to fund. Left to fund: ".concat(leftToFund);
    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(NotEnoughFundsError).call(this, {
      code: 'not_enough_error',
      message: message
    }));
    _this7.leftToFund = leftToFund;
    _this7.name = 'NotEnoughFundsError';
    _this7.message = message;
    return _this7;
  }

  return NotEnoughFundsError;
}(BlockstackError);

exports.NotEnoughFundsError = NotEnoughFundsError;
/**
* @ignore
*/

var InvalidAmountError =
/*#__PURE__*/
function (_BlockstackError7) {
  _inherits(InvalidAmountError, _BlockstackError7);

  function InvalidAmountError(fees, specifiedAmount) {
    var _this8;

    _classCallCheck(this, InvalidAmountError);

    var message = "Not enough coin to fund fees transaction fees. Fees would be ".concat(fees, ",") + " specified spend is  ".concat(specifiedAmount);
    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(InvalidAmountError).call(this, {
      code: 'invalid_amount_error',
      message: message
    }));
    _this8.specifiedAmount = specifiedAmount;
    _this8.fees = fees;
    _this8.name = 'InvalidAmountError';
    _this8.message = message;
    return _this8;
  }

  return InvalidAmountError;
}(BlockstackError);

exports.InvalidAmountError = InvalidAmountError;
/**
* @ignore
*/

var LoginFailedError =
/*#__PURE__*/
function (_BlockstackError8) {
  _inherits(LoginFailedError, _BlockstackError8);

  function LoginFailedError(reason) {
    var _this9;

    _classCallCheck(this, LoginFailedError);

    var message = "Failed to login: ".concat(reason);
    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(LoginFailedError).call(this, {
      code: 'login_failed',
      message: message
    }));
    _this9.message = message;
    _this9.name = 'LoginFailedError';
    return _this9;
  }

  return LoginFailedError;
}(BlockstackError);

exports.LoginFailedError = LoginFailedError;
/**
* @ignore
*/

var SignatureVerificationError =
/*#__PURE__*/
function (_BlockstackError9) {
  _inherits(SignatureVerificationError, _BlockstackError9);

  function SignatureVerificationError(reason) {
    var _this10;

    _classCallCheck(this, SignatureVerificationError);

    var message = "Failed to verify signature: ".concat(reason);
    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(SignatureVerificationError).call(this, {
      code: 'signature_verification_failure',
      message: message
    }));
    _this10.message = message;
    _this10.name = 'SignatureVerificationError';
    return _this10;
  }

  return SignatureVerificationError;
}(BlockstackError);

exports.SignatureVerificationError = SignatureVerificationError;
/**
* @ignore
*/

var InvalidStateError =
/*#__PURE__*/
function (_BlockstackError10) {
  _inherits(InvalidStateError, _BlockstackError10);

  function InvalidStateError(message) {
    var _this11;

    _classCallCheck(this, InvalidStateError);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(InvalidStateError).call(this, {
      code: exports.ERROR_CODES.INVALID_STATE,
      message: message
    }));
    _this11.message = message;
    _this11.name = 'InvalidStateError';
    return _this11;
  }

  return InvalidStateError;
}(BlockstackError);

exports.InvalidStateError = InvalidStateError;
/**
* @ignore
*/

var NoSessionDataError =
/*#__PURE__*/
function (_BlockstackError11) {
  _inherits(NoSessionDataError, _BlockstackError11);

  function NoSessionDataError(message) {
    var _this12;

    _classCallCheck(this, NoSessionDataError);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(NoSessionDataError).call(this, {
      code: exports.ERROR_CODES.INVALID_STATE,
      message: message
    }));
    _this12.message = message;
    _this12.name = 'NoSessionDataError';
    return _this12;
  }

  return NoSessionDataError;
}(BlockstackError);

exports.NoSessionDataError = NoSessionDataError;